import { cn } from "@/lib/utils";
import { getSportVisual } from "@/lib/sportVisuals";

export const SportBadge = ({ activity, sport, className, showIcon = true }) => {
  const visual = getSportVisual(activity || sport);
  const Icon = visual.icon;

  return (
    <span
      className={cn("app-badge", className)}
      style={{
        color: visual.accent,
        background: visual.soft,
        borderColor: `${visual.accent}44`,
      }}
      data-sport={visual.sport}
      data-testid="sport-badge"
    >
      {showIcon && Icon ? (
        <Icon className="w-3 h-3" strokeWidth={1.75} aria-hidden="true" />
      ) : null}
      {visual.label}
    </span>
  );
};
